import React from 'react';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import Cell from './Cell';
const styles = {
  row: {
    height: 1,
    '&:nth-child(even)': {
      backgroundColor: '#e6e6e6'
    }
  }
};
const Row = props => {
  const renderColumns = () => {
    return props.children.map((cell, i) => {
      return /*#__PURE__*/React.createElement(Cell, {
        key: i
      }, cell);
    });
  };
  return /*#__PURE__*/React.createElement(TableRow, {
    className: props.classes.row,
    "data-testid": "defiForm-Row"
  }, renderColumns());
};
export default withStyles(styles)(Row);